<template>
  <div>
    <div class="elevation-1">
      <v-toolbar flat color="white">
        <v-toolbar-title> TIPO DE FORNECEDOR </v-toolbar-title>
        <v-divider class="mx-4" inset vertical></v-divider>
        <v-toolbar-title v-if="providerType.id"
          >{{ providerType.id }} -
          {{ providerType.name.toUpperCase() }}</v-toolbar-title
        >
        <v-spacer></v-spacer>
        <v-btn outlined color="grey darken-3" @click="goToBackList()">
          <v-icon left>mdi-chevron-left</v-icon> Voltar
        </v-btn>
        <v-progress-linear
          :active="loading"
          :indeterminate="loading"
          absolute
          bottom
          color="deep-purple accent-4"
        ></v-progress-linear>
      </v-toolbar>
      <v-form ref="form" v-model="valid" :lazy-validation="lazy">
        <v-container fluid>
          <v-row>
            <v-col cols="12" xs="12" md="4">
              <v-text-field
                v-model="providerType.name"
                class="text-field-uppercase"
                label="Nome"
                dense
                outlined
                required
                :rules="[rules.required]"
              ></v-text-field>
            </v-col>
            <v-col cols="12" xs="12" md="4"> </v-col>
          </v-row>
          <v-row>
            <v-col>
              <v-btn color="blue darken-3" dark class="mt-5" @click="validate">
                <v-icon left>mdi-send</v-icon> Salvar
              </v-btn>
            </v-col>
          </v-row>
        </v-container>
      </v-form>
    </div>
  </div>
</template>

<script>
import * as API from "@/api/requests/ProviderTypeRequest";
export default {
  components: {},
  data: () => ({
    loading: false,
    providerType: {
      id: "",
      name: "",
    },
    valid: true,
    lazy: false,
    rules: {
      required: (value) => !!value || "Campo Obrigatorio",
    },
  }),
  computed: {},
  created() {
    this.initialize();
  },
  methods: {
    async initialize() {
      if (this.$route.params.id) {
        this.getProviderType(this.$route.params.id);
      }
    },
    async getProviderType(id) {
      this.loading = true;
      try {
        let response = await API.getById(id);
        this.providerType = response;
      } catch (error) {
        this.providerType = {};
        console.log(error);
      } finally {
        this.loading = false;
      }
    },
    goToBackList() {
      this.$router.push({ name: "ProviderType" });
    },
    validate() {
      if (this.$refs.form.validate()) {
        this.providerType.name = this.providerType.name.toUpperCase();
        let data = { ...this.providerType };
        if (this.providerType.id === "") {
          this.post(data);
        } else {
          this.update(this.providerType.id, data);
        }
      }
    },
    async post(data) {
      this.loading = true;
      try {
        let res = await API.post(data);
        console.log(res);
        this.goToBackList();
      } catch (error) {
        console.log(error);
      } finally {
        this.loading = false;
      }
    },
    async update(id, data) {
      this.loading = true;
      try {
        let res = await API.update(id, data);
        console.log(res);
        this.goToBackList();
      } catch (error) {
        console.log(error);
      } finally {
        this.loading = false;
      }
    },
  },
};
</script>
<style>
.text-field-uppercase input {
  text-transform: uppercase;
}
</style>
